












import Vue from 'vue'
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'

import {
    STATO_IN_ATTESA,
    COLOR_STATO_IN_ATTESA,
    COLOR_STATO_IN_CARICO,
    STATO_IN_CARICO,
    STATO_IN_PROGRAMMAZIONE,
    COLOR_STATO_IN_PROGRAMMAZIONE,
    COLOR_STATO_LAVORI_IN_CORSO,
    STATO_LAVORI_IN_CORSO,
    STATO_CHIUSA,
    COLOR_STATO_CHIUSA
} from '../../../costanti_report'

export default Vue.extend({
    computed: {
        ...mapState('reportAdmin', ['segnalazioneSelezionata']),
        ...mapGetters('reportMappa', ['segnalazioniFiltrate'])
    },
    methods: {
        ...mapActions('reportMappa', ['caricaSegnalazioni', 'caricaStatoSegnalazioni']),
        ...mapMutations('reportAdmin', ['SET_SEGNALAZIONE_SELEZIONATA']),
        getColoreDalloStato(stato) {
            switch (stato) {
                case STATO_IN_ATTESA:
                    return COLOR_STATO_IN_ATTESA
                case STATO_IN_CARICO:
                    return COLOR_STATO_IN_CARICO
                case STATO_IN_PROGRAMMAZIONE:
                    return COLOR_STATO_IN_PROGRAMMAZIONE
                case STATO_LAVORI_IN_CORSO:
                    return COLOR_STATO_LAVORI_IN_CORSO
                case STATO_CHIUSA:
                    return COLOR_STATO_CHIUSA
            }
        }
    },
    created() {
        // carichiamo le cose
        this.caricaSegnalazioni({light: false})
        this.caricaStatoSegnalazioni()
    }
})
